import { Suspense, useEffect, useLayoutEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { resetDocumentScrollToTop } from "./utils/resetDocumentScrollToTop";
import "./App.css";
import Header from "./components/Header/Header";
import CookieBanner from "./components/CookieBanner/CookieBanner";
import ExitIntentLead from "./components/ExitIntentLead/ExitIntentLead";
import { ModalProvider } from "./hooks/useModal";
import { scroller } from "react-scroll";
import Main from "./components/Main/Main";
import React from "react";
import NotFound from "./components/NotFound/NotFound";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { useAbVariant } from "./hooks/useAbVariant";

// Ленивая загрузка остальных компонентов
const Quiz = React.lazy(() => import("./components/Quiz/Quiz"));
const Recommendations = React.lazy(() => import("./components/Recommendations/Recommendations"));
const Doctors = React.lazy(() => import("./components/Doctors/Doctors"));
const Clinic = React.lazy(() => import("./components/Clinic/Clinic"));
const Checkups = React.lazy(() => import("./components/Checkups/Checkups"));
const Reviews = React.lazy(() => import("./components/Reviews/Reviews"));
const Licenses = React.lazy(() => import("./components/Licenses/Licenses"));
const Faq = React.lazy(() => import("./components/Faq/Faq"));
const Services = React.lazy(() => import("./components/Services/Services"));
const Categories = React.lazy(() => import("./components/Categories/Categories"));
const Contacts = React.lazy(() => import("./components/Contacts/Contacts"));
const Footer = React.lazy(() => import("./components/Footer/Footer"));
const PolzovatelskoeSoglashenie = React.lazy(() => import("./components/PolzovatelskoeSoglashenie/PolzovatelskoeSoglashenie"));
const Gallery = React.lazy(() => import("./components/Gallery/Gallery"));
const Banner = React.lazy(() => import("./components/Banner/Banner"));
const BannerSlider = React.lazy(() => import("./components/BannerSlider/BannerSlider"));
// A/B-тест: hero и фиксированная кнопка варианта B грузятся лениво,
// чтобы не утяжелять основной (дефолтный) вариант A.
const MainB = React.lazy(() => import("./components/Main/MainB"));
const StickyCta = React.lazy(() => import("./components/StickyCta/StickyCta"));
// Вариант C: урезанная страница (Hero, Doctors, Reviews, Contacts + правовая строка).
const LegalFooter = React.lazy(() => import("./components/LegalFooter/LegalFooter"));

import LazyOnView from "./components/LazyOnView";

const AGREEMENT_PATH = "/polzovatelskoe-soglashenie";

function ScrollOnAgreementRoute() {
  const { pathname, key } = useLocation();

  useLayoutEffect(() => {
    if (pathname !== AGREEMENT_PATH) return;
    resetDocumentScrollToTop();
  }, [pathname, key]);

  useEffect(() => {
    if (pathname !== AGREEMENT_PATH) return;
    resetDocumentScrollToTop();
    const t0 = setTimeout(resetDocumentScrollToTop, 0);
    const t1 = setTimeout(resetDocumentScrollToTop, 50);
    const t2 = setTimeout(resetDocumentScrollToTop, 150);
    return () => {
      clearTimeout(t0);
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, [pathname, key]);

  return null;
}

const navItems = [
  { href: "#main", text: "Главная", section: "main" },
  { href: "#doctors", text: "Врачи", section: "doctors" },
  { href: "#reviews", text: "Отзывы", section: "reviews" },
  { href: "#licenses", text: "Лицензии", section: "licenses" },
  { href: "#faq", text: "Вопросы", section: "faq" },
  { href: "#gallery", text: "Дети", section: "gallery" },
];

// Вариант C: на странице только эти секции — оставляем в меню только их пункты.
const VARIANT_C_SECTIONS = ["main", "doctors", "reviews"];
const navItemsC = navItems.filter((i) => VARIANT_C_SECTIONS.includes(i.section));
 // Фотографии
import img0 from './images/childs/DSC06722.webp';
import img1 from './images/childs/220636212.webp';
import img3 from './images/childs/220635225.webp';
import img4 from './images/childs/DSC07056_sized.webp';
import img5 from './images/childs/220636020.webp';
import img6 from './images/childs/220636109.webp';
import img7 from './images/childs/220634318_sized.webp';
import img8 from './images/childs/220634617_sized.webp';
import img9 from './images/childs/220634852_sized.webp';
import img10 from './images/childs/220635069_sized.webp';
import img11 from './images/childs/220635358.webp';
import img12 from './images/childs/220636010.webp';
import img13 from './images/childs/220636041.webp';
import img14 from './images/childs/220636133.webp';
import img15 from './images/childs/220634380_sized.webp';
import img16 from './images/childs/220634669.webp';
import img17 from './images/childs/220635023.webp';
import img18 from './images/childs/220635289.webp';
import img19 from './images/childs/220635391_sized.webp';
import img20 from './images/childs/220636015.webp';
import img21 from './images/childs/220636093.webp';
import img22 from './images/childs/220635981.webp';
import img23 from './images/childs/220634505.webp';
import img24 from './images/childs/220634255.webp';
import img25 from './images/childs/DSC06999_sized.webp';
import img26 from './images/childs/220634757_sized.webp';
import img27 from './images/childs/DSC06984.webp';
import img28 from './images/childs/DSC06271_sized.webp';
import img29 from './images/childs/DSC06645_sized.webp';
import img30 from './images/childs/DSC06415_sized.webp';
import img31 from './images/childs/DSC06397_sized.webp';
import img32 from './images/childs/DSC06363_sized.webp';
import img33 from './images/childs/DSC06728.webp';

// Видео
import videoChilds from "./video/childs_sized.mp4"

// Врачи
import imgDoctorOne from "./images/doctors/barakhoyeva.webp";
import imgDoctorOneSmall from "./images/doctors/barakhoyeva_small.webp";
import imgDoctorTwo from "./images/doctors/dementieva.webp";
import imgDoctorTwoSmall from "./images/doctors/dementieva_small.webp";
import imgDoctorThree from "./images/doctors/khachaturyan.webp";
import imgDoctorThreeSmall from "./images/doctors/khachaturyan_small.webp";
import imgDoctorFour from "./images/doctors/lisova.webp";
import imgDoctorFourSmall from "./images/doctors/lisova_small.webp";
import imgDoctorFive from "./images/doctors/osina.webp";
import imgDoctorFiveSmall from "./images/doctors/osina_small.webp";
import imgDoctorSeven from "./images/doctors/volkova.webp";
import imgDoctorSevenSmall from "./images/doctors/volkova_small.webp";
import imgDoctorEight from "./images/doctors/malahova.webp";
import imgDoctorEightSmall from "./images/doctors/malahova_small.webp";
import imgDoctorNine from "./images/doctors/cheremnyh.webp";
import imgDoctorNineSmall from "./images/doctors/cheremnyh_small.webp";
import imgDoctorTen from "./images/doctors/ladygina.webp";
import imgDoctorTenSmall from "./images/doctors/ladygina_small.webp";
import InfertilityCausesBlock from "./components/InfertilityCausesBlock/InfertilityCausesBlock";



const imagesDoctors = {
  barakhoyeva: { large: imgDoctorOne, small: imgDoctorOneSmall },
  dementieva: { large: imgDoctorTwo, small: imgDoctorTwoSmall },
  khachaturyan: { large: imgDoctorThree, small: imgDoctorThreeSmall },
  lisova: { large: imgDoctorFour, small: imgDoctorFourSmall },
  osina: { large: imgDoctorFive, small: imgDoctorFiveSmall },
  volkova: { large: imgDoctorSeven, small: imgDoctorSevenSmall },
  malahova: { large: imgDoctorEight, small: imgDoctorEightSmall },
  cheremnyh: { large: imgDoctorNine, small: imgDoctorNineSmall },
  ladygina: { large: imgDoctorTen, small: imgDoctorTenSmall },
};

export const photos = [
  { id: 1, src: img0 },
  { id: 2, src: img1 },
  { id: 'Видео', src: videoChilds, type: 'video' },
  { id: 3, src: img3 },
  { id: 4, src: img4, objectPosition: 'top' },
  { id: 5, src: img5 },
  { id: 6, src: img6 },
  { id: 7, src: img7, objectPosition: 'top' },
  { id: 8, src: img8, objectPosition: 'top' },
  { id: 9, src: img9, objectPosition: 'top' },
  { id: 10, src: img10, objectPosition: 'top' },
  { id: 11, src: img11 },
  { id: 12, src: img12 },
  { id: 13, src: img13 },
  { id: 14, src: img14 },
  { id: 15, src: img15, objectPosition: 'top' },
  { id: 16, src: img16 },
  { id: 17, src: img17 },
  { id: 18, src: img18 },
  { id: 19, src: img19, objectPosition: 'top' },
  { id: 20, src: img20 },
  { id: 21, src: img21 },
  { id: 22, src: img22 },
  { id: 23, src: img23 },
  { id: 24, src: img24 },
  { id: 25, src: img25 },
  { id: 26, src: img26, objectPosition: 'top' },
  { id: 27, src: img27 },
  { id: 28, src: img28 },
  { id: 29, src: img29 },
  { id: 30, src: img30 },
  { id: 31, src: img31 },
  { id: 32, src: img32 },
  { id: 33, src: img33 },
];


function App() {
  const [showClone, setShowClone] = useState(false);
  const abVariant = useAbVariant();
  const isB = abVariant === "b";
  const isC = abVariant === "c";

  // Передаём вариант в Яндекс.Метрику, чтобы сравнивать конверсию A vs B.
  useEffect(() => {
    let tries = 0;
    const send = () => {
      if (window.ym) {
        window.ym(9956731, "params", { ab_test: abVariant });
        return true;
      }
      return false;
    };
    if (send()) return;
    const id = setInterval(() => {
      tries += 1;
      if (send() || tries > 20) clearInterval(id);
    }, 500);
    return () => clearInterval(id);
  }, [abVariant]);

  useEffect(() => {
    // 1. получаем id без '#' и без параметров
    const id = window.location.hash.replace(/^#/, '').split('?')[0];
    // 2. если в navItems нет такого section — выходим
    if (!navItems.some(i => i.section === id)) return;

    // функция скролла
    const scroll = () => scroller.scrollTo(id, { smooth: false, offset: -80, duration: 500 });

    // первый вызов на следующем кадре, второй — через 500 мс
    let rafId = requestAnimationFrame(scroll);
    const timer1 = setTimeout(scroll, 500);
    const timer2 = setTimeout(scroll, 1000);
    const timer3 = setTimeout(scroll, 1500);
    
    // Очистка таймеров для предотвращения утечек памяти
    return () => {
      cancelAnimationFrame(rafId);
      clearTimeout(timer1);
      clearTimeout(timer2);
      clearTimeout(timer3);
    };
  }, []);

  // Содержимое главной — общее для "/" (вариант A) и "/b" (вариант B).
  // Конкретный вариант определяется через isB (см. useAbVariant).
  const homePage = (
    <>
      {isB ? (
        <Suspense fallback={null}>
          <MainB />
        </Suspense>
      ) : (
        <Main />
      )}
      <Banner imagesDoctors={imagesDoctors} />
      <Suspense fallback={null}>
        <Recommendations />
      </Suspense>
      <Suspense fallback={null}>
        <Doctors imagesDoctors={imagesDoctors} />
      </Suspense>
      {/* B: отзывы сразу под врачами */}
      {isB && (
        <Suspense fallback={null}>
          <Reviews />
        </Suspense>
      )}
      <Suspense fallback={null}>
        <InfertilityCausesBlock />
      </Suspense>
      <Suspense fallback={null}>
        <Clinic />
      </Suspense>
      <Suspense fallback={null}>
        <Gallery photos={photos} showClone={showClone} setShowClone={setShowClone} />
      </Suspense>
      {!isB && (
        <Suspense fallback={null}>
          <Quiz />
        </Suspense>
      )}
      <Suspense fallback={null}>
        <Checkups />
      </Suspense>
      {/* A: отзывы на исходном месте */}
      {!isB && (
        <Suspense fallback={null}>
          <Reviews />
        </Suspense>
      )}
      <Suspense fallback={null}>
        <Licenses />
      </Suspense>
      <Suspense fallback={null}>
        <Faq />
      </Suspense>
      {!isB && (
        <Suspense fallback={null}>
          <Services />
        </Suspense>
      )}
      <Suspense fallback={null}>
        <Categories />
      </Suspense>
      {!isB && (
        <Suspense fallback={null}>
          <BannerSlider />
        </Suspense>
      )}
      <Suspense fallback={null}>
        <Contacts />
      </Suspense>
      <Suspense fallback={null}>
        <Footer />
      </Suspense>
    </>
  );

  // Вариант C ("/c"): только Hero, Doctors, Reviews, Contacts, а вместо
  // футера — строка с правовой ссылкой.
  const homePageC = (
    <>
      <Suspense fallback={null}>
        <MainB />
      </Suspense>
      <Suspense fallback={null}>
        <Doctors imagesDoctors={imagesDoctors} />
      </Suspense>
      <Suspense fallback={null}>
        <Reviews />
      </Suspense>
      <Suspense fallback={null}>
        <Contacts />
      </Suspense>
      <Suspense fallback={null}>
        <LegalFooter />
      </Suspense>
    </>
  );

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey="6LdkxCQsAAAAAFBQNrP37NZwYKYcsodChJYz38rl"
      useRecaptchaNet
      language="ru"
      scriptProps={{ async: true, defer: true, appendTo: "head" }}
    >
      <BrowserRouter>
        <ModalProvider>
          <ScrollOnAgreementRoute />
          <Header navItems={isC ? navItemsC : navItems} showClone={showClone} />
          <main>
          <Routes>
            <Route
              path="/polzovatelskoe-soglashenie"
              element={
                <PolzovatelskoeSoglashenie />
              }
            />
            {/* Вариант A — "/", вариант B — "/b" (то же содержимое), вариант C — "/c" (урезанная страница) */}
            <Route path="/" element={isC ? homePageC : homePage} />
            <Route path="/b" element={homePage} />
            <Route path="/c" element={homePageC} />
            <Route
              path="*"
              element={
                <NotFound />
              }
            />
          </Routes>
          {/* <button
            id="scrollToTop"
            className={`scroll_top${isVisible ? " visible" : ""}`}
            onClick={scrollToTop}
            aria-label="Прокрутить вверх"
          ></button> */}
            <CookieBanner />
            <ExitIntentLead />
            {isB && (
              <Suspense fallback={null}>
                <StickyCta />
              </Suspense>
            )}
          </main>
        </ModalProvider>
      </BrowserRouter>
    </GoogleReCaptchaProvider>
  );
}

export default App;
